"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getDate = function getDate() {
  var date = new Date();
  var day = String(date.getDate()).padStart(2, "0");
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var year = String(date.getFullYear());
  return "".concat(year).concat(month).concat(day);
};
var couponHit = function couponHit(language) {
  return "HD".concat(getDate()).concat(language.toUpperCase());
};
var _default = couponHit;
exports["default"] = _default;